import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DatePipe } from '@angular/common';
import { LayoutComponent } from './layout.component';
import { Globals } from 'src/app/globals';
import { LayoutRoutingModule } from './layout-routing.module';
import { SideNavComponent } from '../common/sidenav.component';
import { HeaderComponent } from '../common/header.component';
import { AuthGuard } from '../login/auth.guard';
@NgModule({
    imports: [
        CommonModule,
        LayoutRoutingModule,
    ],

    declarations: [
        LayoutComponent,
        SideNavComponent,
        HeaderComponent
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ],
    providers: [
        DatePipe,
        Globals,
        AuthGuard
    ]
})
export class LayoutModule { }
